import { NavigationGuard } from 'vue-router';

const SLIDE_TRANSITION_GUARD: NavigationGuard = (to, _from) => {
   const toId = to.meta?.id;
   const fromId = _from.meta?.id;
   if (toId && fromId && toId !== fromId) {
      to.meta.transition = fromId < toId ? 'slide-left-page' : 'slide-right-page';
      _from.meta.transition = fromId < toId ? 'slide-left-page' : 'slide-right-page';
   }
};

export default SLIDE_TRANSITION_GUARD;
